import { create } from 'zustand'

import i18n from '@app/i18n'

import { AddressApi } from '@entities/Address'

import { InfoModal, useModalStore } from '@features/modal'
import styles from '@features/modal/ui/styles.module.scss'

import { client } from '@shared/api/client'
import { GeoPoint, ZonesForGeoPointQuery } from '@shared/generated'


const addressApi = new AddressApi(client)

const modalStore = useModalStore.getState()

const t = i18n.t

const openErrorInfoModal = (errorTransKey?: string) => {
  modalStore.openModal('info', <InfoModal />, {
    title: t('common:modal.error.title'),
    description:
      t(`errors:${errorTransKey}`) ?? t('common:modal.error.description'),
    classes: {
      content: styles['error-info-modal-content'],
    },
  })
}

type GeoPointProps = {
  latitude: GeoPoint['latitude'];
  longitude: GeoPoint['longitude'];
};

interface ZonesState {
  currentAddress: string | null;
  zones: ZonesForGeoPointQuery['zonesForGeoPoint'];
  loadingCheckAddressGeopoint: boolean;
  loadingAddreses: boolean;
  isCheking: boolean;
  fetchCheckAddressGeopoint: (
    geoPoint: GeoPointProps,
    onHasAddress?: () => void,
  ) => Promise<void>;
  setZones: (zones: ZonesForGeoPointQuery['zonesForGeoPoint']) => void;
  setCurrentAddress: (newAddress: string | null) => void;
}

export const useZonesStore = create<ZonesState>((set, get) => ({
  currentAddress: null,
  zones: null,
  loadingCheckAddressGeopoint: false,
  loadingAddreses: false,
  isCheking: false,
  fetchCheckAddressGeopoint: async (
    geoPoint: GeoPointProps,
    onHasAddress = () => {},
  ) => {
    if (get().isCheking) return

    set({ isCheking: true })

    try {
      set({
        loadingCheckAddressGeopoint: true,
      })

      const dataZones = await addressApi.zonesForGeopoint(geoPoint)
      const zonesForGeoPoint = dataZones.data?.zonesForGeoPoint

      if (zonesForGeoPoint !== undefined) {
        set({ zones: zonesForGeoPoint })
      }
      else {
        set({ zones: null })
      }

      const addressResponse = await addressApi.searchAddress(geoPoint)

      const address =
        addressResponse.data?.searchForAddressSuggestions?.suggestions?.[0]
          ?.value

      if (address) {
        set({
          currentAddress: address,
        })
        onHasAddress()
      }
    }
    catch (error) {
      console.error('fetchZonesGeopoint error: ', error)
      openErrorInfoModal('fetch_zones')
    }
    finally {
      set({ isCheking: false })
      set({
        loadingCheckAddressGeopoint: false,
      })
    }
  },
  setZones: (zones) => set({ zones }),
  setCurrentAddress: (newAddress) =>
    set({
      currentAddress: newAddress,
    }),
}))
